import { createSlice } from '@reduxjs/toolkit';

/**
 * UI 状态管理 Slice
 */
const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    // 全局加载状态
    globalLoading: false,
    // 侧边栏收起状态
    sidebarCollapsed: false,
    // 当前页面标题
    pageTitle: '',
  },
  reducers: {
    // 设置全局加载
    setGlobalLoading: (state, action) => {
      state.globalLoading = action.payload;
    },
    // 切换侧边栏
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    // 设置侧边栏状态
    setSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload;
    },
    // 设置页面标题
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
    },
  },
});

export const {
  setGlobalLoading,
  toggleSidebar,
  setSidebarCollapsed,
  setPageTitle,
} = uiSlice.actions;

export default uiSlice.reducer;

// 选择器
export const selectGlobalLoading = (state) => state.ui.globalLoading;
export const selectSidebarCollapsed = (state) => state.ui.sidebarCollapsed;
export const selectPageTitle = (state) => state.ui.pageTitle;
